import { Input, Component } from '@angular/core';
import { EventBusService } from 'app/shared/services/event-bus.service';
import { AppEventType } from 'app/shared/models/app-events.model';

@Component({
    selector: 'gaweb-page-transition',
    template: `
    <div class="container" *ngIf="!loaded">
        <div class="loader" [ngClass]="{'loader--top':position === 'top'}">
            <i class="fa fa-spinner fa-pulse fa-5x "></i>
        </div>
    </div>
    `
})
export class PageTransitionComponent {
    @Input() position: string;
    loaded: boolean;
    closeEventListener: any;

    constructor(private eventBusService: EventBusService) {
        this.loaded = false;
        const onLoaded = (event) => {
            this.loaded = true;
        };
        this.closeEventListener = this.eventBusService.on$(AppEventType.PageLoadedEvent)
            .subscribe(onLoaded);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/page-transition/page-transition.component.ts